import React from "react";
import { useTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import * as actions from "../../actions";
import ErrorMessage from "../errorMessage";
import "./index.css";

const Diagnostics = (props) => {
    const t = useTranslation()[0];
    const [testing, setTesting] = React.useState(false);
    const [result, setResult] = React.useState(null);

    const runTest = async () => {
        setTesting(true);
        setResult(null);
        const report = await actions.runConnectivityCheck(props.tenantId);
        setResult(report);
        setTesting(false);
    };

    return (
        <div className="diagnosticsContainer">
            <h2>{t("diagnostics.title")}</h2>
            <Button
                onClick={runTest}
                disabled={testing}
                variant="outlined">
                {testing ? t("diagnostics.testing") : t("diagnostics.test")}
            </Button>
            {testing && <div className="diagnosticsSpinner"><CircularProgress size={24} /></div>}
            {result && !testing &&
                <div className="diagnosticsResult">
                    {result.missingTenant && <p>{t("diagnostics.missingTenant")}</p>}
                    {result.ok && <p className="diagnosticsOk">{t("diagnostics.ok")}</p>}
                    {!result.ok && !result.missingTenant &&
                        <ErrorMessage
                            error={result.error}
                            tenant={props.tenantId}
                            branch={props.branchName} />
                    }
                </div>
            }
        </div>
    );
};
export default Diagnostics;
